const ACCESS = "kanban.access";
const REFRESH = "kanban.refresh";

export function accessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS);
  } catch {
    return null;
  }
}

export async function refreshAccess(): Promise<boolean> {
  let refresh: string | null = null;
  try {
    refresh = localStorage.getItem(REFRESH);
  } catch {
    return false;
  }
  if (!refresh) return false;
  const response = await fetch("/api/v1/auth/refresh", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: refresh }),
  });
  if (!response.ok) return false;
  const body = (await response.json()) as { access_token: string; refresh_token: string };
  localStorage.setItem(ACCESS, body.access_token);
  localStorage.setItem(REFRESH, body.refresh_token);
  return true;
}
